import React, { useState } from "react"
import PropTypes from "prop-types"
import { format } from "d3-format"
import { Select, Container, Box } from "datastory-shared/ui"

import TrendLines from "../charts/TrendLines"

import { MissingDataNotification } from "components/blocks"

const excludedIds = ["og:pirate-party-swe", "og:feminist-initiative-swe"]

const TrendsViewByParty = ({
  polls,
  trends,
  metaPolls,
  metaParties,
  sources,
  annotations,
  xDomains,
  onXDomainChange,
  isCompleteDataLoaded,
}) => {
  const [source, setSource] = useState("mama")
  const [party, setParty] = useState("og:moderate-party-swe")

  const { isArray } = Array

  if (
    !isArray(polls) ||
    !isArray(trends) ||
    !isArray(metaPolls) ||
    !isArray(metaParties)
  )
    return <MissingDataNotification />

  const visiblePolls =
    source === "mama"
      ? ["og:scb", "og:sifo", "og:demoskop", "og:novus", "og:ipsos"]
      : [source]
  const pollsData = polls.filter(
    p => p.og_politicalParty === party && visiblePolls.includes(p.og_pollster)
  )

  return (
    <Container maxW="container.md" data-cy="polls-chart-trends-by-party">
      <TrendLines
        isButtonGroupAtTop={false}
        polls={pollsData}
        trends={trends}
        metaPolls={metaPolls}
        metaParties={metaParties}
        trendFormula={source}
        yDomain={[0, 40]}
        yTickValues={[0, 4, 15, 25, 35, 40]}
        annotations={annotations}
        selected={[party]}
        visibilityNonSelected={"hidden"}
        drawPollLines
        xDomains={xDomains}
        onXDomainChange={onXDomainChange}
        isCompleteDataLoaded={isCompleteDataLoaded}
        showLineTooltip={false}
        pointTooltipFormat={d => `
            <div style="margin-bottom: 0.25rem; font-size: 0.875rem;">
              ${d.date_formatted}
            </div>
            <div style="font-size: 1rem">
              ${d.pollster} ${format(".1f")(d.value)}%
            </div>
          `}
        pointTooltipSticky
      >
        <>
          <Box gridColumn={["span 12", "span 6"]}>
            <Select
              onChange={setParty}
              value={party}
              options={metaParties.filter(p => !excludedIds.includes(p.id))}
              style={{ width: "100%" }}
              size="large"
            />
          </Box>
          <Box gridColumn={["span 12", "span 6"]}>
            <Select
              onChange={setSource}
              options={sources}
              value={source}
              style={{ width: "100%" }}
              size="large"
            />
          </Box>
        </>
      </TrendLines>
    </Container>
  )
}

TrendsViewByParty.propTypes = {
  polls: PropTypes.array,
  trends: PropTypes.array.isRequired,
  metaParties: PropTypes.array.isRequired,
  metaPolls: PropTypes.array.isRequired,
  sources: PropTypes.array,
  annotations: PropTypes.array,
  xDomains: PropTypes.array,
  onXDomainChange: PropTypes.func,
  isCompleteDataLoaded: PropTypes.bool,
}

export default TrendsViewByParty
